import React from 'react';
import Info from '../../svg-icons/info';
import {teal100} from '../../assets/less/base/_variables';
import { Link } from 'react-router-dom';

export default class GridTitle extends React.PureComponent{
    render(){
        return(
            <div className="content-block-title">
                <h3>{this.props.titleText}</h3>
                {this.props.itemsCount > 0 ?
                  <p className="count hide-mobile">Showing {this.props.pageItemsCount} of {this.props.itemsCount} open orders</p> :
                  null
                }
                <Link to = "/queries" className="button button-small button-icon-right button-white color-blue">
                    View All
                </Link>
            </div>
        );
    }
}
